export const useCheckUpdates = () => {
  console.log("Expo Update disabled for web build.")
}
